const store = {
  namespaced: true,
  state: {
    eventRules: [],
    operator: {
      gt: '大于',
      lt: '小于',
      gte: '大于等于',
      lte: '小于等于',
      equals: '等于',
      all: '包含所有',
      any: '包含任一',
    },
    type: {
      NUM: ['gt', 'lt', 'gte', 'lte', 'equals'],
      STR: ['equals', 'all', 'any'],
    },
  },
  mutations: {
    SET_EVENT_RULES(state, eventRules) {
      state.eventRules = eventRules;
    },
    UPDATE_EVENT_RULE(state, eventRule) {
      state.eventRules.splice(eventRule.index, 1, {
        conditions: eventRule.conditions,
        action: eventRule.action,
        action_data: eventRule.action_data,
        first_valid: eventRule.first_valid,
      })
    },
    ADD_EVENT_RULE(state, eventRule) {
      state.eventRules.push(eventRule)
    },
    DEL_EVENT_RULE(state, index) {
      if (index < 0) return;
      state.eventRules.splice(index, 1)
    },
    MODIFY_POSITION(state, { originalP = 0, newP = 0 }) {
      const data = state.eventRules[originalP];
      state.eventRules.splice(originalP, 1);
      state.eventRules.splice(newP, 0, data);
    },
  },
  actions: {
    setEventRule({ state, commit, dispatch }, curRule) {
      if (curRule.index >= 0) {
        commit('UPDATE_EVENT_RULE', curRule);
      } else {
        commit('ADD_EVENT_RULE', curRule);
      }
      return dispatch('scene/savePortionScene', { key: 'event_rules', data: state.eventRules }, { root: true })
    },
    setEventRules({ commit }, eventRules = []) {
      commit('SET_EVENT_RULES', eventRules)
    },
    delEventRule({ commit, dispatch, state }, index) {
      commit('DEL_EVENT_RULE', index)
      return dispatch('scene/savePortionScene', { key: 'event_rules', data: state.eventRules }, { root: true })
    }, 
    // 修改位置
    modifyPosition({ commit, dispatch, state }, positionInfo) {
      commit('MODIFY_POSITION', positionInfo);
      return dispatch('scene/savePortionScene', { key: 'event_rules', data: state.eventRules }, { root: true })
    },
  }
}
export default store

